// error messages
export const EVOLUTIVE_CROSSING_NETWORK_ERROR = {
  title: 'Ops! Algo deu errado',
  message: 'Atualize a página e tente novamente'
};

// success messages
export const EDIT_COMPLETED = {
  title: "Edição Concluída",
  message: "Suas alterações foram salvas"
};

export const ALTERNATIVE_SENT = {
  title: "Alternativa enviada",
  message: "A alternativa foi enviada para o grupo escolhido"
};

export const QUESTION_SENT = {
  title: "Pergunta enviada",
  message: "A pergunta foi enviada para o grupo escolhido"
};

export const COMBINED_QUESTIONS = {
  title: "Perguntas combinadas",
  message: "O grupo de perguntas foi criado"
};

export const COMBINED_ALTERNATIVES = {
  title: "Alternativas combinadas",
  message: "O grupo de alternativas foi criado"
};

export const DELETED_QUESTION = {
  title: "Pergunta excluída",
  message: "A pergunta voltou a ser avulsa"
};

export const DELETED_QUESTION_AND_DISSOLVE_GROUP = {
  title: "Pergunta excluída",
  message: "A pergunta voltou a ser avulsa e a combinação foi desfeita"
};

export const DELETED_ALTERNATIVE = {
  title: "Alternativa excluída",
  message: "A alternativa voltou a ser avulsa"
};

export const DELETED_ALTERNATIVE_AND_DISSOLVE_GROUP = {
  title: "Alternativa excluída",
  message: "A alternativa voltou a ser avulsa e a combinação foi desfeita"
};

export const FINAL_PAYLOAD_SENT = {
  title: "Sucesso",
  message: "Evolutivo de Cruzamento Configurado"
};

//warnning menssages
export const COMBINE_ALTERNATIVES_WITH_SAME_SURVEYID = {
  title: "Alerta",
  message: "Não é possivel combinar alternativa(s) que pertencem a mesma pesquisa"
};

export const SEND_ALTERNATIVES_WITH_SAME_SURVEYID = {
  title: "Alerta",
  message: "Não é possivel enviar alternativa(s) que pertencem a mesma pesquisa"
};

export const COMBINE_QUESTIONS_WITH_SAME_SURVEYID = {
  title: "Alerta",
  message: "Não é possivel combinar pergunta(s) que pertencem a mesma pesquisa"
};

export const SEND_QUESTIONS_WITH_SAME_SURVEYID = {
  title: "Alerta",
  message: "Não é possivel enviar pergunta(s) que pertencem a mesma pesquisa"
};
